export const USER_STATUS = {
  ACTIVE: 1,
  CLOSED: 2,
};

export const ACTION_LIST = {
  CAN_CREATE_WEB: 1,
  CAN_CREATE_TEMPLATE: 2,
  CAN_PASS_APPLICATION: 3,
};

export const ACTION_LIST_NAMES = {
  [ACTION_LIST.CAN_CREATE_WEB]: 'Может создавать вебинары',
  [ACTION_LIST.CAN_CREATE_TEMPLATE]: 'Может создавать шаблоны',
  [ACTION_LIST.CAN_PASS_APPLICATION]: 'Может передавать обращение между сотрудниками',
};
